<script setup lang="ts">
import type { SelectItemProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { IconCheck } from '@tabler/icons-vue';
import { SelectItem, SelectItemIndicator, SelectItemText, useForwardProps } from 'reka-ui';
import { cn } from '@ui/lib/utils.js';

const props = defineProps<SelectItemProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <SelectItem
        data-slot="select-item"
        v-bind="forwardedProps"
        :class="
            cn(
                'text-foreground-primary',
                'hover:bg-surface-accent-1',
                'focus:bg-surface-accent-1',
                'focus-visible:ring-ring-default',
                '[&_svg:not([class*=\'text-\'])]:text-muted-foreground',
                'relative',
                'flex',
                'w-full',
                'cursor-default',
                'items-center',
                'gap-2',
                'rounded-sm',
                'py-1.5',
                'pr-8',
                'pl-2',
                'paragraph-sm',
                'outline-hidden',
                'select-none',
                'data-[disabled]:pointer-events-none',
                'data-[disabled]:opacity-50',
                '[&_svg]:pointer-events-none',
                '[&_svg]:shrink-0',
                '[&_svg:not([class*=\'size-\'])]:size-4',
                '*:[span]:last:flex',
                '*:[span]:last:items-center',
                '*:[span]:last:gap-2',
                props.class,
            )
        "
    >
        <span class="absolute right-2 flex size-3.5 items-center justify-center">
            <SelectItemIndicator>
                <slot name="indicator-icon">
                    <IconCheck class="size-4" />
                </slot>
            </SelectItemIndicator>
        </span>

        <SelectItemText>
            <slot />
        </SelectItemText>
    </SelectItem>
</template>
